import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import pagination from '@/components/layout/pagination/Pagination.vue'
import { BSpinner, BToast } from 'bootstrap-vue'
import mensagens from '@/util/mensagens'
import util from '@/util'
import imageStream from '@/components/layout/imageStream/ImageStream.vue'
import { mapState } from 'vuex'

export default {
  name: 'galeriaFotos',
  components: {
    cabecalho,
    menuLateral,
    pagination,
    imageStream,
    'b-spinner': BSpinner,
    'b-toast': BToast
  },

  computed: {
    ...mapState('pagination', ['registrosPorPagina']),
    tabelaSemRegistros () {
      return this.listaAlbuns.length === 0
    }
  },

  data: () => {
    return {
      listaAlbuns: [],
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      },
      componentePaginacao: {
        pagina: 1,
        registrosPorPagina: null,
        fonteDeDados: [],
        ultimaPagina: 1
      }
    }
  },

  mounted () {
    this.componentePaginacao.registrosPorPagina = this.registrosPorPagina
    this.obterListaAlbuns()
  },

  methods: {
    async obterListaAlbuns () {
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)

        let parametrosRequisicao = {
          'page': this.componentePaginacao.pagina,
          'registrosPorPagina': this.componentePaginacao.registrosPorPagina
        }
        const resposta = await this.axios.post('/albuns', parametrosRequisicao)
        this.listaAlbuns = resposta.data.retorno.dados
        this.componentePaginacao.fonteDeDados = resposta.data.retorno.paginacao
        this.componentePaginacao.ultimaPagina = resposta.data.retorno.paginacao.ultimaPagina
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    obterDadosPaginados (pagina, registrosPorPagina) {
      this.componentePaginacao.pagina = pagina
      this.componentePaginacao.registrosPorPagina = registrosPorPagina
      this.obterListaAlbuns()
    },

    detalhesAlbum (id) {
      this.$router.push({ name: 'detalhes-galeriaFotos', params: { id: id } })
    }
  }
}
